import {useDebugValue} from 'react';

import {noop} from '../../../utils';

import {useEvents} from './';

const defaultEvents = {
    onSettingsChange: noop,
    onSubmit: noop
};

function useFormEvents(props) {
    const {
        formEvents: propsEvents
    } = props;

    const {
        events
    } = useEvents(defaultEvents, propsEvents);

    const result = {
        events
    };

    useDebugValue(result);

    return result;
}

export {useFormEvents};
